var CalendarType = /*#__PURE__*/function (CalendarType) {
  CalendarType["WALMART"] = "walmart";
  CalendarType["STANDARD"] = "standard";
  return CalendarType;
}({});

export { CalendarType };
